import React, {useState, useEffect, useMemo} from "react"
import "@/styles/RyderLivescoring.css"
import RyderLivescoringDefaultView from "@/components/RyderLivescoring/views/default/RyderLivescoringDefaultView"
import RyderLivescoringNin9rsView from "@/components/RyderLivescoring/views/nin9rs/RyderLivescoringNin9rsView"
import { initSocketEvents } from "@/util/socket"
import { handleRyderLivescoringSocketResponse } from "@/methods/ryderLivescoring_methods"

const RyderLivescoring = ({ data, isGroupingView = false, customDesign = null }) => {
    const [stateData, setStateData] = useState(data || {competition: {}, teams: {}, rounds: {}})

    const varEnv = stateData.env
    const socketChannel = data.socketChannel

    useEffect(() => {
        const unsubscribeFromSocket = initSocketEvents({
            channel: socketChannel,
            action: (response) => handleRyderLivescoringSocketResponse(response, varEnv, setStateData)
        })

        return () => {
            unsubscribeFromSocket()
        }
    }, [socketChannel])

    const teams = stateData.teams || {}
    const rounds = stateData.rounds || {}
    const competitionOrganiser = stateData.competition?.organiser || ""
    const teamIds = Object.keys(teams)
    const [first, second] = teamIds
    const teamColors = {
        [first]: teams[first]?.color,
        [second]: teams[second]?.color,
    }

    const sessions = useMemo(() => {
        const filtered = Object.entries(rounds)
            .filter(([, r]) => r.matches && Object.keys(r.matches).length > 0)
            .sort(([, a], [, b]) => a.order - b.order)

        return filtered.map(([id, round], idx) => {
            const matchesArray = Object.entries(round.matches)

            matchesArray.sort(([, a], [, b]) => {
                return a.order - b.order
            })

            let sessionName = `Round ${idx + 1}`
            if ("CM00" === competitionOrganiser) {
                const modality = (round.modality || "").toString().trim()
                sessionName = "individual" === modality.toLowerCase()
                    ? "INDIVIDUALES"
                    : modality.toUpperCase()
            }

            return {
                id,
                name: sessionName,
                modality: round.modality,
                date: new Date(round.initial_date.date).toLocaleDateString("es-ES", {
                    day: "2-digit",
                    month: "short",
                    year: "numeric",
                }),
                matches: matchesArray.map(([mid, m]) => ({
                    id: mid,
                    ...m,
                })),
            }
        })
    }, [rounds, competitionOrganiser])

    const [activeTab, setActiveTab] = useState(sessions[0]?.id || "")

    if ("nin9rs" === customDesign) {
        return <RyderLivescoringNin9rsView
            teams={teams}
            isGroupingView={isGroupingView}
            stateData={stateData}
            setActiveTab={setActiveTab}
            sessions={sessions}
            activeTab={activeTab}
            teamColors={teamColors}
            customDesign={customDesign}
        />
    } else {
        return <RyderLivescoringDefaultView
            teams={teams}
            isGroupingView={isGroupingView}
            stateData={stateData}
            setActiveTab={setActiveTab}
            sessions={sessions}
            activeTab={activeTab}
            teamColors={teamColors}
            customDesign={customDesign}
        />
    }
}

export default RyderLivescoring
